import React from "react";
import {
  LuLayoutGrid, LuArrowRight, LuCheck, LuStar, LuCode, LuGlobe,
  LuSmartphone, LuCloud, LuBrain, LuSettings, LuUsers, LuRocket,
  LuTrendingUp, LuShield, LuZap, LuDatabase, LuLayers, LuTarget,
  LuHeadphones, LuMail, LuPhone, LuMapPin, LuBuilding, LuBriefcase,
  LuMonitor, LuTablet, LuCpu, LuWifi, LuLock, LuChartBar as LuBarChart2,
  LuFileText, LuImage, LuVideo, LuMusic, LuCalendar, LuClock,
  LuSearch, LuFilter, LuDownload, LuUpload, LuLink, LuShare2,
  LuHeart, LuBookmark, LuBell, LuMessageSquare, LuSend, LuRefreshCw,
  LuPenTool, LuScissors, LuBox, LuPackage, LuTruck, LuShoppingCart,
  LuDollarSign, LuCreditCard, LuFileChartPie as LuPieChart, LuActivity, LuAward,
  LuFlag, LuTag, LuBookOpen, LuGraduationCap, LuMicroscope, LuFlaskRound as LuFlask,
  LuChevronRight, LuChevronDown, LuChevronUp, LuArrowUp, LuMenu,
  LuX, LuPlus, LuMinus, LuPenTool as LuEdit, LuTrash2, LuEye, LuEyeOff,
} from "react-icons/lu";

const LuIconsMap = {
  LuLayoutGrid, LuArrowRight, LuCheck, LuStar, LuCode, LuGlobe,
  LuSmartphone, LuCloud, LuBrain, LuSettings, LuUsers, LuRocket,
  LuTrendingUp, LuShield, LuZap, LuDatabase, LuLayers, LuTarget,
  LuHeadphones, LuMail, LuPhone, LuMapPin, LuBuilding, LuBriefcase,
  LuMonitor, LuTablet, LuCpu, LuWifi, LuLock, LuBarChart2,
  LuFileText, LuImage, LuVideo, LuMusic, LuCalendar, LuClock,
  LuSearch, LuFilter, LuDownload, LuUpload, LuLink, LuShare2,
  LuHeart, LuBookmark, LuBell, LuMessageSquare, LuSend, LuRefreshCw,
  LuPenTool, LuScissors, LuBox, LuPackage, LuTruck, LuShoppingCart,
  LuDollarSign, LuCreditCard, LuPieChart, LuActivity, LuAward,
  LuFlag, LuTag, LuBookOpen, LuGraduationCap, LuMicroscope, LuFlask,
  LuChevronRight, LuChevronDown, LuChevronUp, LuArrowUp, LuMenu,
  LuX, LuPlus, LuMinus, LuEdit, LuTrash2, LuEye, LuEyeOff,
};

const getImageUrl = (url) => {
  if (!url || typeof url !== "string") return "";
  if (url.startsWith("data:") || url.startsWith("blob:")) return url;
  
  let finalUrl = url;
  const apiUrl = (process.env.NEXT_PUBLIC_API_URL || process.env.NEXT_PUBLIC_API_BASE_URL || '').replace(/\/api\/?$/, '').replace(/\/$/, '') || "";
  
  if (url.includes("/uploads/")) {
    const cleanPath = url.substring(url.indexOf("/uploads/"));
    finalUrl = `${apiUrl}${cleanPath}`;
  } else if (url.startsWith("uploads/") || url.startsWith("/uploads/")) {
    const cleanPath = url.startsWith("/") ? url : `/${url}`;
    finalUrl = `${apiUrl}${cleanPath}`;
  } else if (url.startsWith("http")) {
    finalUrl = url;
  }

  if (finalUrl.includes("res.cloudinary.com") && finalUrl.includes("/image/upload/")) {
    if (!finalUrl.includes("f_auto") && !finalUrl.includes("q_auto")) {
      finalUrl = finalUrl.replace("/image/upload/", "/image/upload/f_auto,q_auto/");
    }
  }
  return finalUrl;
};

function SafeIcon({ iconName, size = 24 }) {
  const [imgError, setImgError] = React.useState(false);

  if (!iconName) return <LuLayoutGrid size={size} />;
  const iconStr = typeof iconName === 'string' ? iconName : (iconName?.url || '');
  if (!iconStr) return <LuLayoutGrid size={size} />;

  const isImage = iconStr.startsWith("http") || iconStr.startsWith("/") || iconStr.includes("uploads") || iconStr.includes("blob:");
  if (isImage && !imgError) {
    return (
      <img
        src={getImageUrl(iconStr)}
        alt="Icon"
        style={{ width: size, height: size, objectFit: "contain" }}
        onError={() => setImgError(true)}
      />
    );
  }

  if (iconStr.startsWith("fa-") || iconStr.includes(" ")) {
    return <i className={iconStr} style={{ fontSize: size }} />;
  }

  const formattedName = iconStr.startsWith("Lu") ? iconStr : `Lu${iconStr}`;
  const IconComponent = LuIconsMap[formattedName] || LuLayoutGrid;
  return <IconComponent size={size} />;
}

const renderIcon = (iconName, size = 24) => <SafeIcon iconName={iconName} size={size} />;

export default function WhyChooseSection({ data }) {
  return (
    <section className="stats-section text-white py-3">
      <div className="container text-center">
        <div className="row justify-content-center circle-text ">
          {data?.statCard && data.statCard.length > 0 ? (
            data.statCard.map((stat, idx) => (
              <div
                key={idx}
                className="col-6 col-md-3 "
                data-aos="fade-up"
                data-aos-delay={idx * 100}
              >
                <div className="stat-circle mx-auto d-flex flex-column align-items-center justify-content-center">
                  <h2>{stat.value}</h2>
                  <p>{stat.label}</p>
                </div>
              </div>
            ))
          ) : (
            <>
              <div
                className="col-6 col-md-3 "
                data-aos="fade-up"
                data-aos-delay="0"
              >
                <div className="stat-circle mx-auto d-flex flex-column align-items-center justify-content-center">
                  <h2>12+</h2>
                  <p>Years of Industry Experience</p>
                </div>
              </div>
              <div
                className="col-6 col-md-3 "
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <div className="stat-circle mx-auto d-flex flex-column align-items-center justify-content-center">
                  <h2>200+</h2>
                  <p>Successful Projects Delivered</p>
                </div>
              </div>
              <div
                className="col-6 col-md-3 "
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="stat-circle mx-auto d-flex flex-column align-items-center justify-content-center">
                  <h2>150+</h2>
                  <p>Satisfied Clients</p>
                </div>
              </div>
              <div
                className="col-6 col-md-3 "
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <div className="stat-circle mx-auto d-flex flex-column align-items-center justify-content-center">
                  <h2>160+</h2>
                  <p>5 Star Reviews</p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="container-fluid mt-5 ">
        <div className="row text-center text-team">
          {data?.cards && data.cards.length > 0 ? (
            data.cards.map((card, idx) => (
              <div
                key={idx}
                className="col-lg-4 col-md-6 mb-3"
                data-aos="fade-up"
                data-aos-delay={(idx % 3) * 100}
              >
                <div className="feature-card">
                  <div className="feature-icon">
                    {renderIcon(card.icon || "Rocket")}
                  </div>
                  <h3 className="feature-title">{card.title}</h3>
                  <p className="feature-description">{card.description}</p>
                </div>
              </div>
            ))
          ) : (
            <>
              <div
                className="col-lg-4 col-md-6 mb-3"
                data-aos="fade-up"
                data-aos-delay="0"
              >
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fa-solid fa-rocket"></i>
                  </div>
                  <h3 className="feature-title">Our Proven Track Record</h3>
                  <p className="feature-description">
                    {`With over 12 years of experience, we've delivered 200+
                    successful projects, earning the trust of 150+ satisfied
                    clients and achieving 160 five-star reviews. Our proven track
                    record showcases our commitment to excellence and client
                    satisfaction.`}
                  </p>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6 mb-3"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fa-solid fa-diagram-project"></i>
                  </div>
                  <h3 className="feature-title">Personalized Solutions</h3>
                  <p className="feature-description">
                    We provide customized strategies tailored to your specific
                    goals, target audience, and industry, ensuring optimal results
                    and engagement.
                  </p>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6 mb-3"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fa-solid fa-users-viewfinder"></i>
                  </div>
                  <h3 className="feature-title">Client-Centric Focus</h3>
                  <p className="feature-description">
                    Your success is our priority. We focus on understanding your
                    business goals to deliver personalized solutions that meet
                    your unique needs.
                  </p>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="row mt-4 text-center">
          <div className="col">
            <div className="bs-tags-row custom-tags-row" style={{ marginBottom: 0 }}>
              {data?.tags && data.tags.length > 0 ? (
                data.tags.map((tag, idx) => (
                  <span
                    key={idx}
                    className="bs-tag custom-tag"
                    data-aos="fade-up"
                    data-aos-delay={idx * 100}
                  >
                    <span className="bs-tag-icon">✦</span>{tag}
                  </span>
                ))
              ) : (
                <>
                  <span
                    className="bs-tag custom-tag"
                    data-aos="fade-up"
                    data-aos-delay="0"
                  >
                    <span className="bs-tag-icon">✦</span>Ongoing Innovation
                  </span>
                  <span
                    className="bs-tag custom-tag"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <span className="bs-tag-icon">✦</span>Dedicated Assistance
                  </span>
                  <span
                    className="bs-tag custom-tag"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    <span className="bs-tag-icon">✦</span>Client Satisfaction
                  </span>
                  <span
                    className="bs-tag custom-tag"
                    data-aos="fade-up"
                    data-aos-delay="300"
                  >
                    <span className="bs-tag-icon">✦</span>Quality Excellence
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
